module.exports = __webpack_public_path__ + "static/media/1_A1_18.f68fc392.png";